<template>
  <div data-page-name="ootbi-best-storage-for-veeam">
    <main>
      <section class="hero">
        <div class="wrapper">
          <div class="content">
            <AppLogo />

            <h1 v-html="$t('Best_Storage_for_Veeam')" />
            <p>{{ $t('ootbi-best-storage-for-veeam.hero.description') }}</p>

            <Buttons.Anchor anchor="form">
              {{ $t('Request_a_demo') }}
              <SvgIcon name="arrow-forward" />
            </Buttons.Anchor>
          </div>
        </div>

        <NuxtImg
          class="screenshot"
          src="/redesign/images/screenshots/dashboard.webp"
          alt="Object First dashboard screenshot"
          width="1078"
          height="719"
          sizes="xs:479 md:1078"
          densities="x1 x2"
          format="webp"
        />
      </section>

      <section class="why-ootbi">
        <div class="wrapper">
          <h2>{{ $t('ootbi-best-storage-for-veeam.why-ootbi.h2') }}</h2>

          <section class="ransomware-attacks-statistics">
            <h3>
              {{
                $t(
                  'ootbi-best-storage-for-veeam.why-ootbi.ransomware-attacks-statistics.h3',
                )
              }}
            </h3>
            <p>
              {{
                $t(
                  'ootbi-best-storage-for-veeam.why-ootbi.ransomware-attacks-statistics.p',
                )
              }}
            </p>

            <Buttons.Anchor anchor="form">
              {{ $t('Request_a_demo') }}
              <SvgIcon name="arrow-forward" />
            </Buttons.Anchor>

            <div class="content">
              <ul>
                <li>
                  <strong>{{
                    $t(
                      'ootbi-best-storage-for-veeam.why-ootbi.ransomware-attacks-statistics.content.ul.li-1.strong',
                    )
                  }}</strong>
                  <span>{{
                    $t(
                      'ootbi-best-storage-for-veeam.why-ootbi.ransomware-attacks-statistics.content.ul.li-1.span',
                    )
                  }}</span>
                </li>

                <li>
                  <strong>{{
                    $t(
                      'ootbi-best-storage-for-veeam.why-ootbi.ransomware-attacks-statistics.content.ul.li-2.strong',
                    )
                  }}</strong>
                  <span>{{
                    $t(
                      'ootbi-best-storage-for-veeam.why-ootbi.ransomware-attacks-statistics.content.ul.li-2.span',
                    )
                  }}</span>
                </li>

                <li>
                  <strong>{{
                    $t(
                      'ootbi-best-storage-for-veeam.why-ootbi.ransomware-attacks-statistics.content.ul.li-3.strong',
                    )
                  }}</strong>
                  <span>{{
                    $t(
                      'ootbi-best-storage-for-veeam.why-ootbi.ransomware-attacks-statistics.content.ul.li-3.span',
                    )
                  }}</span>
                </li>
              </ul>

              <span class="sources">
                {{ $t('Sources') }}:

                <NuxtLink
                  to="https://www.comparitech.com/blog/information-security/us-ransomware-attacks-cost/"
                  target="_blank"
                  rel="nofollow"
                >
                  comparitech.com</NuxtLink
                >,
                <!-- prevents whitespace between link and comma -->

                <NuxtLink
                  to="https://www.ibm.com/reports/data-breach"
                  target="_blank"
                  rel="nofollow"
                >
                  ibm.com</NuxtLink
                >,
                <!-- prevents whitespace between link and comma -->

                <NuxtLink
                  to="https://www.statista.com/statistics/494947/ransomware-attempts-per-year-worldwide/"
                  target="_blank"
                  rel="nofollow"
                >
                  statista.com
                </NuxtLink>
              </span>
            </div>
          </section>

          <p>{{ $t('ootbi-best-storage-for-veeam.why-ootbi.p') }}</p>
          <strong
            v-html="$t('ootbi-best-storage-for-veeam.why-ootbi.strong')"
          />

          <section class="benefits">
            <div class="left">
              <p>
                {{
                  $t('ootbi-best-storage-for-veeam.why-ootbi.benefits.left.p')
                }}
              </p>
              <strong>{{
                $t(
                  'ootbi-best-storage-for-veeam.why-ootbi.benefits.left.strong',
                )
              }}</strong>

              <Buttons.Anchor anchor="form" fill="solid" accent="white">
                <span>{{ $t('Request_a_demo') }}</span>
                <SvgIcon name="arrow-forward" />
              </Buttons.Anchor>
            </div>

            <div class="right">
              <strong>{{
                $t(
                  'ootbi-best-storage-for-veeam.why-ootbi.benefits.right.strong',
                )
              }}</strong>

              <ul>
                <li>
                  {{
                    $t(
                      'ootbi-best-storage-for-veeam.why-ootbi.benefits.right.ul.li-1',
                    )
                  }}
                </li>
                <li>
                  {{
                    $t(
                      'ootbi-best-storage-for-veeam.why-ootbi.benefits.right.ul.li-2',
                    )
                  }}
                </li>
                <li>
                  {{
                    $t(
                      'ootbi-best-storage-for-veeam.why-ootbi.benefits.right.ul.li-3',
                    )
                  }}
                </li>
                <li>
                  {{
                    $t(
                      'ootbi-best-storage-for-veeam.why-ootbi.benefits.right.ul.li-4',
                    )
                  }}
                </li>
              </ul>
            </div>
          </section>
        </div>
      </section>

      <section class="why-best">
        <div class="wrapper">
          <h2>{{ $t('ootbi-best-storage-for-veeam.why-best.title') }}</h2>

          <section class="ootbi">
            <div class="intro">
              <div class="left">
                <h3>
                  {{
                    $t(
                      'ootbi-best-storage-for-veeam.why-best.ootbi.intro.left.h3',
                    )
                  }}
                </h3>
                <p>
                  {{
                    $t(
                      'ootbi-best-storage-for-veeam.why-best.ootbi.intro.left.p',
                    )
                  }}
                </p>
              </div>

              <div class="right">
                <Buttons.Anchor anchor="form" fill="outline">
                  <span class="nowrap">{{ $t('Request_a_demo') }}</span>
                  <SvgIcon name="arrow-forward" fill="inherit" />
                </Buttons.Anchor>
              </div>
            </div>

            <div class="content">
              <ul>
                <li>
                  <h4>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.ootbi.content.ul.li-1.h4',
                      )
                    }}
                  </h4>
                  <p>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.ootbi.content.ul.li-1.p',
                      )
                    }}
                  </p>
                </li>

                <li>
                  <h4>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.ootbi.content.ul.li-2.h4',
                      )
                    }}
                  </h4>
                  <p>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.ootbi.content.ul.li-2.p',
                      )
                    }}
                  </p>
                </li>

                <li>
                  <h4>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.ootbi.content.ul.li-3.h4',
                      )
                    }}
                  </h4>
                  <p>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.ootbi.content.ul.li-3.p',
                      )
                    }}
                  </p>
                </li>
              </ul>

              <NuxtImg
                :alt="
                  $t('ootbi-best-storage-for-veeam.image.alt.new-bucket-popup')
                "
                class="screenshot-new-bucket"
                src="/img/landings/widget-1f@2x.png"
                width="448"
                height="454"
                sizes="md:720 xl:448"
                densities="x1 x2"
                format="webp"
                loading="lazy"
              />
            </div>
          </section>

          <section class="simplicity">
            <div class="intro">
              <div class="left">
                <h3>
                  {{
                    $t(
                      'ootbi-best-storage-for-veeam.why-best.simplicity.intro.left.h3',
                    )
                  }}
                </h3>
                <p>
                  {{
                    $t(
                      'ootbi-best-storage-for-veeam.why-best.simplicity.intro.left.p',
                    )
                  }}
                </p>
              </div>

              <div class="right">
                <Buttons.Anchor anchor="form" fill="outline">
                  <span class="nowrap">{{ $t('Request_a_demo') }}</span>
                  <SvgIcon name="arrow-forward" fill="inherit" />
                </Buttons.Anchor>
              </div>
            </div>

            <div class="content inverted">
              <ul>
                <li>
                  <h4>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.simplicity.content.ul.li-1.h4',
                      )
                    }}
                  </h4>
                  <p>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.simplicity.content.ul.li-1.p',
                      )
                    }}
                  </p>
                </li>

                <li>
                  <h4>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.simplicity.content.ul.li-2.h4',
                      )
                    }}
                  </h4>
                  <p>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.simplicity.content.ul.li-2.p',
                      )
                    }}
                  </p>
                </li>

                <li>
                  <h4>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.simplicity.content.ul.li-3.h4',
                      )
                    }}
                  </h4>
                  <p>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.simplicity.content.ul.li-3.p',
                      )
                    }}
                  </p>
                </li>
              </ul>

              <NuxtImg
                :alt="
                  $t('ootbi-best-storage-for-veeam.image.alt.veeam-server-logo')
                "
                src="/img/landings/server-with-veeam-badges.webp"
                width="1184"
                height="1200"
                densities="1x 2x"
                sizes="md:720 xl:448"
                format="webp"
                loading="lazy"
              />
            </div>
          </section>

          <section class="built-power">
            <div class="intro">
              <div class="left">
                <h3>
                  {{
                    $t(
                      'ootbi-best-storage-for-veeam.why-best.built-power.intro.left.h3',
                    )
                  }}
                </h3>
                <p>
                  {{
                    $t(
                      'ootbi-best-storage-for-veeam.why-best.built-power.intro.left.p',
                    )
                  }}
                </p>
              </div>

              <div class="right">
                <Buttons.Anchor anchor="form" fill="outline">
                  <span class="nowrap">{{ $t('Request_a_demo') }}</span>
                  <SvgIcon name="arrow-forward" fill="inherit" />
                </Buttons.Anchor>
              </div>
            </div>

            <div class="content">
              <ul>
                <li>
                  <h4>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.built-power.content.ul.li-1.h4',
                      )
                    }}
                  </h4>
                  <p>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.built-power.content.ul.li-1.p',
                      )
                    }}
                  </p>
                </li>

                <li>
                  <h4>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.built-power.content.ul.li-2.h4',
                      )
                    }}
                  </h4>
                  <p>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.built-power.content.ul.li-2.p-1',
                      )
                    }}
                  </p>
                  <p>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.built-power.content.ul.li-2.p-2',
                      )
                    }}
                  </p>
                </li>

                <li>
                  <h4>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.built-power.content.ul.li-3.h4',
                      )
                    }}
                  </h4>
                  <p>
                    {{
                      $t(
                        'ootbi-best-storage-for-veeam.why-best.built-power.content.ul.li-3.p',
                      )
                    }}
                  </p>
                </li>
              </ul>

              <NuxtImg
                :alt="
                  $t(
                    'ootbi-best-storage-for-veeam.image.alt.network-adapter-details',
                  )
                "
                class="screenshot-network-adapter"
                src="/img/landings/widget-3@2x.png"
                width="592"
                height="600"
                sizes="md:720px xl:592px"
                densities="1x 2x"
                loading="lazy"
                format="webp"
              />
            </div>
          </section>
        </div>
      </section>

      <section class="experience-matters">
        <div class="wrapper">
          <h2>
            {{ $t('ootbi-best-storage-for-veeam.experience-matters.h2') }}
          </h2>

          <div class="intro">
            <div class="left">
              <h3>
                {{
                  $t(
                    'ootbi-best-storage-for-veeam.experience-matters.intro.left.h3',
                  )
                }}
              </h3>
              <p>
                {{
                  $t(
                    'ootbi-best-storage-for-veeam.experience-matters.intro.left.p',
                  )
                }}
              </p>
            </div>

            <div class="right">
              <Buttons.Anchor anchor="form" fill="outline">
                <span class="nowrap">{{ $t('Request_a_demo') }}</span>
                <SvgIcon name="arrow-forward" fill="inherit" />
              </Buttons.Anchor>
            </div>
          </div>

          <div class="feedback">
            <div class="top">
              <div class="left">
                <strong>Brent Earls</strong>
                <span>{{ $t('position.Chief_Technology_Officer') }}</span>
              </div>

              <div class="right">
                <NuxtImg
                  src="/redesign/images/partners/Mirazon_color.webp"
                  alt="Mirazon color logo"
                  width="160"
                  height="32"
                />
              </div>
            </div>

            <hr />

            <div class="bottom">
              <div class="left">
                <NuxtImg
                  src="/img/Brent_Earls.png"
                  alt="Brent Earls"
                  sizes="xs:120px xl:256px"
                />
              </div>

              <div class="right">
                <q
                  v-html="
                    $t(
                      'ootbi-best-storage-for-veeam.experience-matters.feedback.bottom.right.q',
                    )
                  "
                />

                <Buttons.Link
                  :to="
                    localePathWithSlash(
                      `${PATHS.CASE_STUDIES.path}immutability-out-of-the-box-solved-for-mirazon-and-their-customers/`,
                    )
                  "
                  target="_blank"
                  fill="outline"
                  accent="purple"
                >
                  {{ $t('Read_Customer_Story') }}
                  <SvgIcon name="arrow-forward" />
                </Buttons.Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="form" id="form">
        <div class="wrapper">
          <div class="left">
            <h5>{{ $t('ootbi-best-storage-for-veeam.form.left.h5') }}</h5>
            <p>{{ $t('ootbi-best-storage-for-veeam.form.left.p') }}</p>
          </div>

          <div class="right">
            <Forms.Wrapper>
              <Forms.RequestDemo
                :btn-text="$t('Submit')"
                product="Object Storage"
                page="ootbi-best-storage-for-veeam"
                gtm-event="demo"
                @loading="setLoading"
                @submitted="makeSubmitted"
              />

              <transition appear name="fade">
                <Modals.ThankYou
                  v-if="isSubmitted"
                  :title="$t('Thank_you_for_your_message')"
                  :description="$t('We_already_working') + '!'"
                  :link="{
                    accent: 'purple',
                    href: localePath('/'),
                    text: $t('Visit_Home_Page'),
                  }"
                />
              </transition>
            </Forms.Wrapper>
          </div>
        </div>
      </section>
    </main>

    <FooterLanding />
  </div>
</template>

<script setup lang="ts">
// components
import AppLogo from '~/components/redesign/AppLogo.vue';
import Buttons from '~/components/redesign/Buttons';
import Forms from '~/components/redesign/Forms';
import Modals from '~/components/redesign/Modals';
import FooterLanding from '~/components/redesign/FooterLanding.vue';

// composables
import { useLocalePath } from '#i18n';
import useApiSeo from '~/composables/useApiSeo';
import useLocalePathWithSlash from '~/composables/useLocalePathWithSlash';

// stores
import useUIStore from '~/stores/ui';

// constants
import { PATHS } from '~/constants/nav-items';

const localePath = useLocalePath();
const localePathWithSlash = useLocalePathWithSlash();

const { setLoading } = useUIStore();

const isSubmitted = ref(false);
const makeSubmitted = () => {
  isSubmitted.value = true;
  setLoading(false);
};

definePageMeta({ layout: 'empty' });
useApiSeo('ootbi-best-storage-for-veeam');
</script>

<style scoped lang="scss">
@import '$/mixins/flex';
@import '$/mixins/media';
@import '$/mixins/size';
@import '$/mixins/position';
@import '$/mixins/typography';
@import '$/functions/token';
@import '$/variables/fonts';
@import '$/variables/shadows';
@import '$/variables/colors';

@mixin text {
  font-family: map-get($fonts, 'Inter');
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.875rem;
}

@mixin link {
  @include text;

  color: token('link');
  text-decoration: underline;

  transition: background-color 0.15s ease;

  &:hover {
    background-color: rgba(token('link'), 16%);
  }
}

@mixin h5 {
  font-family: map-get($fonts, 'Poppins');
  font-size: 2rem;
  line-height: 2.375rem;
}

@mixin h6 {
  font-family: map-get($fonts, 'Poppins');
  font-size: 1.75rem;
  line-height: 2.25rem;
}

@mixin q {
  font-family: map-get($fonts, 'Inter');
  font-size: 1.75rem;
  line-height: 2.25rem;
}

@mixin intro {
  @include flex-start-sb;
  gap: 0 6rem;
  margin-bottom: 4rem;

  @include tablet {
    margin-bottom: 0;
  }

  @include mobile {
    gap: 2rem 0;
    flex-direction: column;
  }

  .left {
    h3 {
      @include h3;
      margin-bottom: 2.5rem;

      @include mobile {
        margin-bottom: 1rem;
      }
    }

    p {
      @include text;
    }
  }

  .right {
    @include mobile {
      width: 100%;
    }
  }
}

[data-page-name='ootbi-best-storage-for-veeam'] {
  overflow-x: hidden;

  main {
    section[id] {
      scroll-margin-top: 0;
    }

    section.hero {
      position: relative;
      padding-top: 5rem;
      margin-bottom: 15rem;

      @include tablet {
        padding-top: 2rem;
        margin-bottom: 12rem;
      }

      @include mobile {
        padding-top: 1rem;
        margin-bottom: 3.7rem;
      }

      .wrapper {
        padding: 0 2rem;
        @include wrapper(80rem);

        @include tablet {
          margin-bottom: 1rem;
        }

        @include mobile {
          padding: 0 1rem;
        }

        .content {
          @include fluid-max-width(38rem);
          @include flex-start-start;
          flex-direction: column;

          @include tablet {
            @include fluid-max-width(100%);
          }

          [data-component-name='AppLogo'] {
            @include fixed-width(11rem);
            @include fixed-height(3.625rem);

            margin-bottom: 4rem;

            @include tablet {
              margin-bottom: 2.5rem;
            }

            @include mobile {
              margin-bottom: 2rem;
            }
          }

          &:deep(h1) {
            cursor: text;
            @include h2;
            margin-bottom: 2.5rem;

            @include mobile {
              margin-bottom: 1.5rem;
            }

            span {
              display: inline-block;
              padding: 0 0.5rem;

              position: relative;
              z-index: -1;

              color: token('text-reversed');
              background-color: map-get($colors, 'green');
            }
          }

          p {
            @include text;
            margin-bottom: 4rem;

            @include tablet {
              margin-bottom: 2.5rem;
            }

            @include mobile {
              margin-bottom: 2rem;
            }
          }

          [data-component-name='Buttons.Anchor'] {
            @include mobile {
              width: 100%;
            }
          }
        }
      }

      img.screenshot {
        position: absolute;
        top: 2.05rem;
        left: calc(50% + 1.2rem);

        @include tablet {
          position: relative;
          top: -0.1rem;
          left: 1.2rem;
        }

        @include mobile {
          top: 0.1rem;
          left: -0.15rem;

          width: 165vw;
          height: auto;
        }
      }
    }

    section.why-ootbi {
      margin-bottom: 14rem;

      @include tablet {
        margin-bottom: 8rem;
      }

      @include mobile {
        margin-bottom: 3rem;
      }

      .wrapper {
        padding: 0 2rem;
        @include wrapper(80rem);

        @include mobile {
          padding: 0 1rem;
        }

        h2 {
          @include h2;
          color: token('text-action');
          margin-bottom: 5rem;

          @include tablet {
            margin-bottom: 4rem;
          }

          @include mobile {
            margin-bottom: 3rem;
          }
        }

        section.ransomware-attacks-statistics {
          padding: 4rem;
          color: token('text-reversed');
          background-color: token('surf-cont-dark');

          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-template-rows: auto;
          grid-gap: 0 2rem;

          margin-bottom: 8rem;

          @include tablet {
            grid-template-columns: repeat(1, 1fr);
            padding: 2.5rem;
            margin-bottom: 5rem;
          }

          @include mobile {
            margin-left: -1rem;
            width: calc(100% + 2rem);
            padding: 2rem 1.5rem;
            margin-bottom: 3rem;
          }

          h3 {
            grid-column: 1/3;
            grid-row: 1/2;

            @include h3;
            width: 100%;
            margin-bottom: 4rem;

            @include tablet {
              grid-column: 1/2;
              grid-row: 1/2;

              margin-bottom: 2.5rem;
            }

            @include mobile {
              margin-bottom: 2rem;
            }
          }

          p {
            grid-column: 1/2;
            grid-row: 2/3;

            align-self: end;

            @include text;
            color: token('text-tertiary');
            margin-bottom: 3rem;

            @include tablet {
              grid-column: 1/2;
              grid-row: 2/3;
            }

            @include mobile {
              margin-bottom: 1.5rem;
            }
          }

          [data-component-name='Buttons.Anchor'] {
            grid-column: 1/2;
            grid-row: 3/4;

            display: block;
            width: max-content;
            height: max-content;

            @include tablet {
              grid-column: 1/2;
              grid-row: 4/5;
            }

            @include mobile {
              width: 100%;
            }
          }

          .content {
            grid-column: 2/3;
            grid-row: 2/4;

            ul {
              li {
                border-top: 1px solid token('outline-primary');

                @include flex-center-start;

                strong,
                span {
                  width: 50%;
                  padding: 2rem 1rem;
                }

                strong {
                  @include h6;
                  color: token('icon-action');
                }

                span {
                  @include body-3;
                }
              }
            }

            span.sources {
              display: block;
              margin-left: auto;
              width: max-content;

              @include caption;
              color: #909294;

              @include tablet {
                margin-left: unset;
                margin-bottom: 2.5rem;
              }

              @include mobile {
                margin-bottom: 2rem;
              }

              a {
                transition: color 0.15s ease;

                &:hover {
                  color: token('text-secondary');
                }
              }
            }

            @include tablet {
              grid-column: 1/2;
              grid-row: 3/4;
            }
          }
        }

        > p {
          @include text;
          @include fluid-max-width(37rem);
          margin-bottom: 1.25rem;
        }

        > :deep(strong) {
          display: block;
          @include text;
          font-weight: 700;
          @include fluid-max-width(37rem);
          margin-bottom: 8rem;

          @include tablet {
            margin-bottom: 5rem;
          }

          @include mobile {
            margin-bottom: 2.5rem;
          }

          span {
            color: token('text-action');
          }
        }

        section.benefits {
          @include flex-center-sb;
          gap: 0 2rem;

          padding: 4rem;
          background: token('surf-cont-secon-action')
            url(/img/landings/3d-top.png) no-repeat;

          @include tablet {
            gap: 2.5rem 0;
            padding: 2.5rem;
            flex-direction: column-reverse;
          }

          @include mobile {
            margin-left: -1rem;
            width: calc(100% + 2rem);
            padding: 2rem 1.5rem;
          }

          .left {
            @include fluid-max-width(37rem);
            color: token('text-reversed');

            @include tablet {
              @include fluid-max-width(100%);
            }

            p {
              @include text;
              margin-bottom: 0.5rem;
            }

            strong {
              @include text;
              font-weight: 700;
              display: block;
              margin-bottom: 3rem;
            }

            [data-component-name='Buttons.Anchor'] {
              display: block;
              width: max-content;

              @include mobile {
                width: 100%;
              }

              span {
                color: token('text-primary');
              }

              svg {
                fill: token('icon-primary');
              }
            }
          }

          .right {
            @include fluid-max-width(24rem);

            padding: 4rem 3rem;
            background-color: token('surf-cont-primary');

            @include tablet {
              padding: 2.5rem;
              @include fluid-max-width(100%);
            }

            @include mobile {
              padding: 1.5rem;
            }

            strong {
              @include text;
              font-weight: 700;
              display: block;
              margin-bottom: 1rem;
            }

            ul {
              list-style: disc;
              margin-left: 2rem;

              li {
                @include text;
              }
            }
          }
        }
      }
    }

    section.why-best {
      margin-bottom: 16rem;

      @include tablet {
        margin-bottom: 5rem;
      }

      @include mobile {
        margin-bottom: 2rem;
      }

      .wrapper {
        padding: 0 2rem;
        @include wrapper(80rem);

        @include mobile {
          padding: 0 1rem;
        }

        h2 {
          @include h2;
          color: token('text-action');
          margin-bottom: 8rem;

          @include tablet {
            margin-bottom: 5rem;
          }

          @include mobile {
            margin-bottom: 2rem;
          }
        }

        section.ootbi,
        section.simplicity,
        section.built-power {
          margin-bottom: 8rem;

          &:last-of-type {
            margin-bottom: 0;
          }

          @include tablet {
            margin-bottom: 5rem;
          }

          @include mobile {
            margin-bottom: 1.5rem;
          }

          .intro {
            @include intro;
          }

          .content {
            @include flex-center-sb;
            gap: 0 2rem;

            @include tablet {
              flex-direction: column-reverse;
            }

            ul {
              li {
                padding: 2rem 0;
                border-top: 1px solid token('outline-secondary');

                @include mobile {
                  padding: 1.5rem 0;
                }

                h4 {
                  @include h6;
                  display: block;
                  margin-bottom: 1.5rem;
                }

                p {
                  @include text;
                }
              }
            }

            img {
              display: block;
              width: 100%;
              height: auto;

              max-width: 28rem;

              @include tablet {
                max-width: 45rem;
                padding: 0;
              }

              &.screenshot-new-bucket {
                padding-top: 4rem;
              }

              &.screenshot-network-adapter {
                padding-bottom: 2rem;
              }
            }

            &.inverted {
              flex-direction: row-reverse;

              @include tablet {
                flex-direction: column-reverse;
              }
            }
          }
        }
      }
    }

    section.experience-matters {
      margin-bottom: 16rem;

      @include tablet {
        margin-bottom: 8rem;
      }

      @include mobile {
        margin-bottom: 2.5rem;
      }

      .wrapper {
        padding: 0 2rem;
        @include wrapper(80rem);

        @include mobile {
          padding: 0 1rem;
        }

        h2 {
          @include h2;
          color: token('text-action');
          margin-bottom: 8rem;

          @include tablet {
            margin-bottom: 5rem;
          }

          @include mobile {
            margin-bottom: 2rem;
          }
        }

        .intro {
          @include intro;

          @include tablet {
            margin-bottom: 4rem;
          }

          @include mobile {
            margin-bottom: 3rem;
          }
        }

        .feedback {
          padding: 4rem;
          box-shadow: map-get($shadows, 'Elevation 3');

          @include tablet {
            padding: 2.5rem;
          }

          @include mobile {
            margin-left: -1rem;
            width: calc(100% + 2rem);
            padding: 2rem 1.5rem;
          }

          .top {
            @include flex-center-sb;
            gap: 0 2rem;
            margin-bottom: 1rem;

            .left {
              @include flex-start-start;
              flex-direction: column;

              @include text;

              strong {
                font-weight: 800;
              }

              span {
              }
            }

            .right {
              img {
              }
            }
          }

          hr {
            margin: 0 0 2rem 0;
            border: none;

            height: 1px;
            width: 100%;
            background-color: token('outline-secondary');
          }

          .bottom {
            @include flex-start-sb;
            gap: 0 4rem;

            @include tablet {
              gap: 2.5rem 0;
              flex-direction: column;
            }

            .left {
              img {
              }
            }

            .right {
              &:deep(q) {
                @include q;
                display: block;
                margin-bottom: 2rem;

                span:first-of-type {
                  display: block;
                  margin-bottom: 1.25rem;
                }
              }

              [data-component-name='Buttons.Link'] {
                display: block;
                width: max-content;
                margin-left: auto;

                @include mobile {
                  width: 100%;
                }

                svg {
                  fill: inherit;
                }
              }
            }
          }
        }
      }
    }

    section.form {
      background: token('surf-cont-secon-action')
        url(/img/landings/3d-form-2.png) no-repeat;

      .wrapper {
        padding: 8rem 2rem;
        @include wrapper(80rem);

        @include flex-stretch-sb;
        gap: 0 2rem;

        @include tablet {
          padding: 5rem 2rem;
          gap: 3.5rem 0;
          flex-direction: column;
        }

        @include mobile {
          gap: 2.5rem 0;
          padding: 2.5rem 1rem 5rem 1rem;
        }

        .left {
          color: token('text-reversed');

          h5 {
            @include h2;
            margin-bottom: 3rem;

            @include tablet {
              margin-bottom: 1.5rem;
            }
          }

          p {
            @include text;
          }
        }

        .right {
          @include wrapper(37rem);

          [data-component-name='Forms.Wrapper'] {
            position: relative;

            @include mobile {
              margin-left: -1rem;
              width: calc(100% + 2rem);
            }

            [data-component-name='Modals.ThankYou'] {
              @include absolute-full;
              z-index: 1;
              padding: 2rem;
              background-color: token('surf-cont-secondary');

              @include tablet {
                padding: 1.5rem;
              }

              @include mobile {
                padding: 1.5rem 1rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>
